import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';
import {
  TopLocationActionTypes,
  TopLocationActions,
} from '@ordersnproducts/modules/new-modify-order/modules/rms-top-location/actions/top-location.actions';

export interface TopLocationFormState {
  forms: RecipeFormValues[];
}

export const initialState: TopLocationFormState = {
  forms: [],
};

export let formCounter = -1;

/**
 * Adds an item to the recipe
 */
const makeRecipeItem = (values: { [key: string]: any }): RecipeFormValues => {
  const id = ++formCounter;
  return {
    id: id,
    values: { ...values },
  };
};

export function rmsSpecificationFormReducer(state = initialState, action: TopLocationActions): TopLocationFormState {
  if (!Object.values(TopLocationActionTypes).includes(action.type)) {
    return state;
  }

  switch (action.type) {
    case TopLocationActionTypes.ADD_ITEM: {
      return {
        ...state,
        forms: [makeRecipeItem(action.payload), ...state.forms],
      };
    }
    case TopLocationActionTypes.UPDATE_ITEM: {
      return {
        ...state,
        forms: state.forms.map(item => {
          if (item.id === action.payload.id) {
            return {
              ...action.payload,
              values: {
                ...action.payload.values,
              },
            };
          } else {
            return item;
          }
        }),
      };
    }
    case TopLocationActionTypes.RESET: {
      formCounter = -1;
      return {
        ...initialState,
      };
    }
    case TopLocationActionTypes.UPDATE_POD:
    case TopLocationActionTypes.UPDATE_POD_MODIFY: {
      state.forms[0].values.pointOfDelivery = action.pod;
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
}
